<div class="back-header">
    <!-- Back Button -->
    <div class="back-icon" (click)="BackWorkGallery()">
        <i class="dx-icon dx-icon-chevronleft"></i>
    </div>
    <!-- Title -->
    <div class="back-text">{{DetailsFormTitle}}</div>
</div>
<div class="form-wrapper">
    <div class="input-grid">

        <div class="separate-input-field">
            <label for="Description" class="lable">Description</label>
            <dx-text-box id="Description" name="Description" [(ngModel)]="Entity.p.description_en" stylingMode="outlined"
                placeholder="Enter Description" [width]="'100%'" class="inputfield">
            </dx-text-box>
        </div>

        <div class="separate-input-field">
            <label for="DescriptionMr" class="lable">Description in देवनागरी</label>
            <dx-text-box id="DescriptionMr" name="DescriptionMr" [(ngModel)]="Entity.p.description_mr"
                stylingMode="outlined" placeholder="Enter Description" [width]="'100%'" class="inputfield">
            </dx-text-box>
        </div>


        <div class="separate-input-field">

            <dx-file-uploader selectButtonText="Upload Photos" accept="image/*" uploadMode="useForm" [multiple]="true"
                [showFileList]="false" (onValueChanged)="onFileSelect($event)"
                [disabled]="SelectedPhotos.length == MAX_PHOTOS">
            </dx-file-uploader>

            <div class="photo-preview" *ngIf="SelectedPhotos.length">
                <div class="img-wrapper" *ngFor="let photo of SelectedPhotos; let i = index">
                    <img [src]="photo.preview" class="preview-img" />
                    <button class="remove-btn" (click)="removePhoto(i)">×</button>
                </div>
            </div>
        </div>

        <!-- READONLY OVERLAY -->
        <div *ngIf="IsReadOnlyMode" class="readonly-overlay"></div>
    </div>
</div>
<div class="button-section" [align]="'center'" style="margin-top: 5rem">
    <app-cancelbutton text="Cancel" (click)="BackWorkGallery()"></app-cancelbutton>
    <dx-button [elementAttr]="{ class: 'save-button' }" (click)="SaveWorkGallery()" [disabled]="isSaveDisabled"
        [text]="IsNewEntity ?  'Save' : 'Update'" type="default" stylingMode="contained" *ngIf="CanAddOrEdit">
    </dx-button>
</div>